export default "/assets/images/chart-sm-06.svg?527d9c4c14b188de751e5bb8e7089f0c";